import { connect } from "./ComponentEx";
import { extend } from "../ExtensionProvider";
import * as React from "react";
/**
 * A control to contain arbitrary controls added through extensions.
 */
class DynDiv extends React.Component {
    render() {
        const { group, objects, orientation } = this.props;
        const visible = objects.filter((obj, idx) => obj.options?.condition === undefined || obj.options.condition({}));
        const classes = ["dyndiv"];
        if (orientation === "vertical") {
            classes.push("dyndiv-vertical");
        }
        else {
            // default to horizontal
            classes.push("dyndiv-horizontal");
        }
        return (React.createElement("div", { id: group, className: classes.join(" ") }, visible.map((comp, idx) => this.renderComponent(comp, idx))));
    }
    renderComponent(object, idx) {
        const props = object.options?.props ?? {};
        return React.createElement(object.component, { key: idx, ...props });
    }
}
function registerDynDiv(instanceGroup, group, component, options) {
    if (instanceGroup === group) {
        return { component, options };
    }
    else {
        return undefined;
    }
}
function mapStateToProps() {
    return {};
}
export default extend(registerDynDiv, "group")(connect(mapStateToProps)(DynDiv));
